import { render } from "./AnnotationsList.vue?vue&type=template&id=cb2ceb3a"
import script from "./AnnotationsList.vue?vue&type=script&lang=js"
export * from "./AnnotationsList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__